module.exports = __webpack_public_path__ + "img/bg5.34d8abf7.png";